const category = {
  PRE_APPROVED: {
    header: 'You are pre-approved<superscript> for another PayPal Business Loan for a limited time!',
    subHeader: 'Based on what we know about your business, there\'s a <highlight> chance you could qualify. Complete this questionnaire to find out. Available for a limited time.',
    disclaimer: '<superscript> Chance of being approved is estimated and not guaranteed, using internal and external data, including your PayPal account history. "Pre-approved" means the estimated chance of approval is 90%+. Subject to credit approval.',
    badgeText: '90%+ chance',
    approvalPercentage: 90,
  },
  VERY_HIGH: {
    header: 'You have an excellent<superscript> chance of getting a PayPal Business Loan for a limited time!',
    subHeader: 'Based on what we know about your business, there\'s an <highlight> chance you could qualify. Complete this questionnaire to find out. Available for a limited time.',
    disclaimer: '<superscript> This is not a pre-approved offer of credit. Chance of being approved is estimated and not guaranteed, using internal and external data, including your PayPal account history. `Excellent` means the estimated chance of approval is 80%+. Subject to credit approval.',
    badgeText: '80%+ chance',
    approvalPercentage: 80,
  },
  HIGH: {
    header: 'You have a great<superscript> chance of getting a PayPal Business Loan for a limited time!',
    subHeader: 'Based on what we know about your business, there\'s a <highlight> chance you could qualify. Complete this questionnaire to find out. Available for a limited time.',
    disclaimer: '<superscript> This is not a pre-approved offer of credit. Chance of being approved is estimated and not guaranteed, using internal and external data, including your PayPal account history. `Great` means the estimated chance of approval is 70%+. Subject to credit approval.',
    badgeText: '70%+ chance',
    approvalPercentage: 70,
  },
  LOW: {
    header: 'You have a very good<superscript> chance of getting a PayPal Business Loan for a limited time!',
    subHeader: 'Based on what we know about your business, there\'s a <highlight> chance you could qualify. Complete this questionnaire to find out. Available for a limited time.',
    disclaimer: '<superscript> This is not a pre-approved offer of credit. Chance of being approved is estimated and not guaranteed, using internal and external data, including your PayPal account history. `Very good` means the estimated chance of approval is 60%+. Subject to credit approval.',
    badgeText: '60%+ chance',
    approvalPercentage: 60,
  },
};

const superScriptText = '1';

export default { category, superScriptText };
